// Hooks for sharing a multi-dataset report with other users (owner/editor/viewer).
// Mirrors use-dashboard-user.js against the parallel `report_users` resource.
import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPost, apiDelete, apiPatch } from 'api'
import AuthContext from 'context/auth-context'

const createReportUser = async (token, params) => {
  const objectName = 'report_user'
  const url = `reports/${params.report_id}/report_users`

  await apiPost({ url, token, objectName, params })
}

export function useCreateReportUser({ params, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    () => {
      return createReportUser(token, params)
    },
    { ...options }
  )
}

const destroyReportUser = async (token, id) => {
  const url = `report_users/${id}`

  await apiDelete({ url, token })
}

export function useDestroyReportUser({ id, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    () => {
      return destroyReportUser(token, id)
    },
    { ...options }
  )
}

const updateReportUser = async (token, id, params) => {
  const objectName = 'report_user'
  const url = `report_users/${id}`

  return await apiPatch({ url, token, objectName, params })
}

export function useUpdateReportUser({ id, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    (params) => {
      return updateReportUser(token, id, params)
    },
    { ...options }
  )
}
